import { ChangeDetectorRef, Component, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { _HttpClient } from '@delon/theme';
import { DateFormatService } from 'src/app/shared/services/date-format.service';
import { SelectBaseComponent } from 'src/app/shared-feature/components/select/select-base';


@Component({
  selector: 'app-sstreturn-select',
  templateUrl: './sstreturn-select.component.html',
  styleUrls: ['./sstreturn-select.component.less'],
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SSTReturnSelectComponent),
      multi: true
    }
  ]
})
export class SSTReturnSelectComponent extends SelectBaseComponent {
  constructor(http: _HttpClient, cdr: ChangeDetectorRef, public dateFormatService: DateFormatService) {
    super(http, cdr);
  }

  getUrl(searchValue: string): string {
    let filter = '';
    if (searchValue) {
      //   filter = `${filter} and (contains(code, '${encodeURIComponent(searchValue)}') or contains(name,'${encodeURIComponent(searchValue)}'))`;
    }
    if (filter)
      return `api/sstreturns/lookup?$top=20&$skip=0&$filter=${filter}`;

    return `api/sstreturns/lookup?$top=20&$skip=0`;
  }
}
